import parse from 'html-react-parser'
import styled from 'styled-components'

import { tr } from 'mmfintech-commons'

export const CustomerConsentStep = () => {
  // const replaceLink = (value: string, find: string, url: string) => {
  //   if (value) {
  //     const list = value.split(find)
  //     if (list.length === 2) {
  //       return list.join(`<a href="${url}" target="_blank">`)
  //     }
  //   }
  //   return value
  // }

  const replaceLinks = (value: string) => {
    // return replaceLink(replaceLink(value, "<a data-type='privacy'>", 'https://'), "<a data-type='terms'>", 'https://')
    return value
  }

  return (
    <CustomerConsentWrapper>
      <p>
        {parse(
          replaceLinks(
            tr(
              'CHECKOUT.CUSTOMER_CONSENT.MESSAGE',
              "By using the service, you agree to AngelsPay's <a data-type='terms'>Terms and Conditions</a> and <a data-type='privacy'>Privacy Policy</a>."
            )
          )
        )}
      </p>
      <p>{tr('CHECKOUT.CUSTOMER_CONSENT.MESSAGE2', 'AngelsPay will retrieve your account information.')}</p>
    </CustomerConsentWrapper>
  )
}

const CustomerConsentWrapper = styled.div`
  padding: 1rem 2rem;
  @media (min-width: 500px) {
    padding: 2rem 4rem;
  }

  font-size: 1.4rem;
`
